export default __webpack_public_path__ + "static/media/no-find.17b1afd2.svg";